export default class FrameFaq {
	private element: HTMLElement
	private triggers: NodeListOf<HTMLElement>

	constructor(element: HTMLElement) {
		this.element = element
		this.triggers = element.querySelectorAll('.frame-content h3')
	}

	init() {
		this.triggers.forEach((h3, index) => {
			const btn = document.createElement('button')
			btn.setAttribute('aria-expanded', 'false')

			const panel = h3.nextElementSibling
			if (panel instanceof HTMLElement) {
				const panelId = `faq-panel-${index}`
				panel.setAttribute('id', panelId)
				panel.setAttribute('aria-hidden', 'true')
				btn.setAttribute('aria-controls', panelId)
			}

			btn.append(...Array.from(h3.childNodes))
			h3.appendChild(btn)

			btn.addEventListener('click', () => this.toggle(h3, btn, panel as HTMLElement))
		})

		this.element.classList.add('is-js-ready')
	}

	private toggle(h3: HTMLElement, btn: HTMLElement, panel: HTMLElement) {
		const isExpanded = btn.getAttribute('aria-expanded') === 'true'
		h3.classList.toggle('isExpanded', !isExpanded)
		btn.setAttribute('aria-expanded', String(!isExpanded))
		if (panel) {
			panel.setAttribute('aria-hidden', String(isExpanded))
		}
	}
}
